import * as React from "react";

import {Ibu, Iuserinfo,iauthData,authDataType} from './AuthContextTypes'
import { returnBasenameUrl } from "../utils";

const fakeAuthProvider={
    signin(){
        // setTimeout(callback, 100); // fake async
    },
    signout(){

    }
}

async function saveUserdata(userData: any):Promise<any>{
    sessionStorage.setItem("ksrgrb2b_moto_userinfo", JSON.stringify(userData));
}

function getInitialState() {
    const authdata = sessionStorage.getItem('ksrgrb2b_moto_userinfo')
    return authdata ? JSON.parse(authdata) : {}
}



//type Tbu = Ibu[];

interface AuthContextType {
    userData: any;
    // // signin: (user: string, callback: VoidFunction) => void;
    // // signout: (callback: VoidFunction) => void;
    // signin: (email: string, password: string, navcallback: VoidFunction) =>  void;
    // signout: (navcallback: VoidFunction) => void;
    signin: (email: string, password: string, navcallback: (motoaccesslevel:number, partsaccesslevel:number, aftersaccesslevel:number)=> void) =>  void;
    signout: (navcallback: ()=>void) => void;
}
  
let AuthContext = React.createContext<AuthContextType>(null!);

function AuthProvider({ children }: { children: React.ReactNode }) {
    let [userData, setUserdata] = React.useState<authDataType | Object>(getInitialState); //  React.useState<any>(null);
    console.log("AuthProvider startup, userData=",userData)
    let authData:authDataType={
        success:false,
        userid:0,
        username:'',
        token:'',
        tokendate: null,
        error:'', 
        refid:'',
        module:'', 
        modulename:'',     
        userinfo: {
            WEBUSERNAME: "",
            WEBUSEREMAIL: "",
            LCOMPANY: "",
            LBRANCH: "",
            bus: Array<Ibu>()
        },
        motoaccesslevel:0,
        partsaccesslevel:0,
        aftersaccesslevel:0,
    };


    // {"action":"login","success":true,"clientid":"9J8p9JL5RqnGM5fiSbP59JT4TrTLULTES4X2I5HnHLTLK59CPd1mIc4bDZ15GYKrGc52G40bDqDXHqz49JOmM2KrHLb5K2KtH5b5LNSbDqHrL5XPHLP09JT4KKXE9JOmH4nGQ69DM5bcLcSbDKDpJKzfLLX9I5PNLoKtH7H79JT2M4D09JT3U4LNL75LLKHqGaD3K51BLcH5LIKsC4LLKKybDKH0G4zqOrGbDq98TLL49JT4PrSbDKLXKa17Q452J4nbLN5fLK10L691G2KsC6LOL4rqKoKtH2KtGtHNOIKrH40",
    // "userid":"305","company":"1001","branch":"1000","appid":"1010","module":"13","refid":"257","modulename":"\u03a0\u03b5\u03bb\u03ac\u03c4\u03b7\u03c2",
    // "userinfo":{"WEBUSERNAME":"sthanos","WEBUSEREMAIL":"tstylianop@gmail.com","LCOMPANY":1001,"LBRANCH":1000,"bus":[{"bu":10,"buname":"Motocycles","trdr":0,"trdbame":"","trdbranch":0,"trdbrnname":"","trdafm":"","whs":"10,11","accesslevel":2}]}}

    React.useEffect(() => {
        sessionStorage.setItem('ksrgrb2b_moto_userinfo', JSON.stringify(userData))
    },[userData])

    /* ksrgrb2b_moto_userinfo:"{"success":true,
    "userid":"305",
    "username":"tstylianop",
    "token":"9J8pKqHCSqTDH50bDK9GKLHHLM....H4LOHa0",
    "error":"",
    "refid":"257",
    "module":"13",
    "modulename":"Πελάτης",
    "userinfo":{
        "WEBUSERNAME":"tstylianop",
        "WEBUSEREMAIL":"tstylianop2@gmail.com",
        "LCOMPANY":1001,"LBRANCH":1000,
        "bus":[
            {"bu":10,
            "buname":"Motocycles",
            "trdr":257,
            "trdbame":"STYLIANOP",
            "trdbranch":0,
            "trdbrnname":"",
            "trdafm":"044224042",
            "whs":"10,11","accesslevel":2}
        ]
    },
    "motoaccesslevel":2,"partsaccesslevel":0,"aftersaccesslevel":0}"
    */
    let signin = (username: string, password:string, navcallback: (motoaccesslevel:number, partsaccesslevel:number, aftersaccesslevel:number)=>void ) => {
        console.log("AuthProvider.signin, newEmail=",username, " password")
        authData={
            success:false,
            userid:0,
            username: '',
            token:'',
            tokendate: null,
            error:'',
            refid:'',
            module:'', 
            modulename:'', 
            userinfo: {
                WEBUSERNAME: "",
                WEBUSEREMAIL: "",
                LCOMPANY: "",
                LBRANCH: "",
                bus: Array<Ibu>()
            },
            motoaccesslevel:0,
            partsaccesslevel:0,
            aftersaccesslevel:0,
        };
        let signinStep=1;
        const ms = Date.now();
        let basename=returnBasenameUrl()
        let url =`${basename}${process.env.REACT_APP_B2B_API_URL}?_t=${ms}`;
        let postdata = {
            service: "S1logininfo",
            username: username,	// username;
            password: password,       
            appId: `${process.env.REACT_APP_APPID}`,    
            apikey:`${process.env.REACT_APP_API_KEY}`
        }
        signinStep=2;
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json','Cache-Control': 'no-cache' },
            body: JSON.stringify(postdata), cache: "no-store" }
        )
        .then((response) =>  {
            signinStep=3;
            if (!response.ok) {
                console.log('login response not ok=',response)
                authData.success=false;
                authData.error="Bad Login Response";
                return {}
            }
            else {
                console.log('login response ok=',response)
                signinStep=4;
                return response.json()
            }
        })
        .then((data:any) => {
            signinStep=5;
            console.log('login response data=',data)
            if(data.success===undefined || data.success===null){
                authData.success=false;
                authData.error="Bad Json Response";
                console.log('login response=',"Bad Json Response")
            }
            else {
                if(data.success===true){
                    console.log('login response=',"data.success===true")
                    authData={
                        success: data.success,
                        userid: data.userid,
                        username: username,
                        token: data.clientid,
                        tokendate: new Date(),
                        error:'',
                        refid: data.refid,
                        module: data.module,
                        modulename: data.modulename,
                        userinfo: {
                            WEBUSERNAME: data.userinfo.WEBUSERNAME,
                            WEBUSEREMAIL: data.userinfo.WEBUSEREMAIL,
                            LCOMPANY: data.userinfo.LCOMPANY,
                            LBRANCH: data.userinfo.LBRANCH,
                            bus: data.userinfo.bus,
                        },
                        motoaccesslevel:0,
                        partsaccesslevel:0,
                        aftersaccesslevel:0
                    };
                    authData.userinfo?.bus?.forEach( (obu) =>{
                        if(`${obu.bu}`===process.env.REACT_APP_BICESBU) authData.motoaccesslevel=obu.accesslevel ? obu.accesslevel : 0
                        if(`${obu.bu}`===process.env.REACT_APP_PARTSBU) authData.partsaccesslevel=obu.accesslevel ? obu.accesslevel : 0
                        if(`${obu.bu}`===process.env.REACT_APP_AFTERSBU) authData.aftersaccesslevel=obu.accesslevel ? obu.accesslevel : 0
                    })

                    // authData = JSON.parse(JSON.stringify(data))   
                }
                else {
                    console.log('login response=',"data.success===false")
                }
            }
        })
        .catch((err) => {
            console.log("login exception=",err.message, "signinStep=",signinStep);
            authData.success=false;
            authData.error="Login exception";        
        })
        .finally(() => {
            console.log("AuthProvider.signin finally: ", authData)            
            setUserdata(authData);
            navcallback(authData.motoaccesslevel,authData.partsaccesslevel,authData.aftersaccesslevel);
        })    
    };

    let signout = (navcallback: ()=>void) => {
        sessionStorage.clear()
        setUserdata({})
        navcallback()
    };
    let value = { userData, signin, signout };
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

function useAuth() {
    return React.useContext(AuthContext);
}

function getAsUserInfo(auth: AuthContextType ) {
    let asuinfo={
      WEBSERVICE: 0,
      bu: 0,
      buname: "",
      trdr: 0,
      trdbame: "",
      trdbranch: 0,
      trdbrnname: "",
      trdafm: "",
      trdemail: "",
      whs: "",
      accesslevel: 0
    };
    auth.userData.userinfo?.bus?.forEach( (obu:any) =>{
        if(`${obu.bu}`===process.env.REACT_APP_AFTERSBU) {
          asuinfo.WEBSERVICE= obu.WEBSERVICE;
          asuinfo.bu=  obu.bu;
          asuinfo.buname=  obu.buname;
          asuinfo.trdr=  obu.trdr;
          asuinfo.trdbame=  obu.trdbame;
          asuinfo.trdbranch=  obu.trdbranch;
          asuinfo.trdbrnname=  obu.trdbrnname;
          asuinfo.trdafm=  obu.trdafm;
          asuinfo.trdemail=  obu.trdemail;
          asuinfo.whs=  obu.whs;
          asuinfo.accesslevel=  obu.accesslevel;
          }     
        }
    );
    return asuinfo;
}

export {AuthProvider, AuthContext, useAuth, getAsUserInfo}


